import { FC } from 'react';

import { AccordionSection, AdaptiveFormConfig } from '@elements';
import { HealthQuoteMember } from '@store/healthquote';
import { InsuredMemberBase } from '@store/proposal/types';
import { Group, Radio, Text, Tooltip } from '@ui';

import classes from '../membersAccordion/MembersAccordion.module.css';

export interface HealthInsuredCustomMember
  extends Omit<InsuredMemberBase, 'relation'> {
  relation: HealthQuoteMember | 'Other';
}

interface NomineeItemProps {
  name: string;
  member: HealthInsuredCustomMember;
  selectedMember?: string;
  setSelectedMember: (memberId?: string) => void;
  fields?: AdaptiveFormConfig;
  hasError?: boolean;
}

const NomineeItem: FC<NomineeItemProps> = ({
  name,
  member,
  selectedMember,
  setSelectedMember,
  fields,
  hasError = false
}) => {
  const isExpanded = selectedMember === member.member_id;

  return (
    <AccordionSection
      key={member.member_id}
      itemValue={`membersAccordion-${member.member_id}`}
      restrictExpansion
      expanded={isExpanded}
      formConfig={fields!}
      // override classes in AccordionSection
      classNames={{
        root: classes.root,
        control: classes.control,
        label: classes.label,
        item: classes.item,
        content: classes.content
      }}
      chevron={null}
      header={
        <Tooltip disabled={isExpanded} label="Check member to select as nominee">
          <Group justify="space-between" align="center" mr="sm">
            <Group gap="xs" wrap="nowrap">
              <Radio
                size="xl"
                name={name}
                checked={selectedMember === member.member_id}
                onChange={() => setSelectedMember(member.member_id)}
              />
              <Text fz={18} fw={600} c={hasError ? 'danger.6' : undefined}>
                {member.full_name}{' '}
                {member.relation !== 'Other' && (
                  <Text fz={14} c="secondary">
                    ({member.relation})
                  </Text>
                )}
              </Text>
            </Group>
          </Group>
        </Tooltip>
      }
    />
  );
};

export { NomineeItem };
